import { ReactNode, CSSProperties } from 'react';

import { useFitScreen } from 'hooks';
import { cn, dynamicStyling } from 'styles';

interface FullHeightContainerProps {
  bottomOffset?: number;
  manageOverflow?: boolean;
  className?: string;
  children: ReactNode;
  id?: string;
  style?: CSSProperties;
}

export function FullHeightContainer({
  children,
  bottomOffset = 0,
  manageOverflow = true,
  className,
  style,
  ...props
}: FullHeightContainerProps) {
  const [maxHeight, setRef] = useFitScreen({ bottomDistance: bottomOffset });

  return (
    <div
      ref={setRef}
      {...props}
      {...dynamicStyling({
        maxHeight,
        height: maxHeight,
        style,
        className: cn('w-full', manageOverflow && 'scrollbar overflow-y-auto', className),
      })}
    >
      {children}
    </div>
  );
}
